export { FlexTemplateStore } from "./FlexTemplateStore";
export { moduleDefinitionToFlexTemplateNode } from "./moduleDefinitionToFlexTemplateNode";
export { flexComponentToFlexTemplateNode } from "./flexComponentToFlexTemplateNode";
export { normalizeOptionsData } from "./normalizeOptionsData";
export { shouldRender, hasRenderableChilren, hasEmptyOptions } from "./shouldRender";

/*
While we are still using BlossomComponentsFactory to iterate through our data,
we need to occasionally create sub-trees of FlexTemplateNodes to support  `shouldRender()` and `hasRenderableChildren()`.
`DescendantDepth` allows us to minimize data duplication in BlossomComponent.flexTemplateNode
When we have migrated away from `<BlossomComponents/>` to `<FlexTemplateRenderer/>` we will no longer need to do this.
FlexTemplateStore will be the source of truth for the page and the entire tree and will be inspectable at any level
*/
export enum DescendantDepth {
  NONE = "NONE",
  CHILDREN = "CHILDREN",
  GRANDCHILDREN = "GRANDCHILDREN",
  ALL = "ALL",
}

export const getNextDepth = (descendantDepth: DescendantDepth): DescendantDepth =>
  descendantDepth === DescendantDepth.ALL
    ? DescendantDepth.ALL
    : descendantDepth === DescendantDepth.GRANDCHILDREN
    ? DescendantDepth.CHILDREN
    : DescendantDepth.NONE;
